export default __webpack_public_path__ + "static/logos-tiles-oreilly-fa2ff60c0f11ee2f7545d34a9de6c2c9.svg";